import Component from '../../components/component/component';

import './map-module.scss';

const OPEN_CLASS: string = 'is-open';

export default class MapModule extends Component {
    static initSelector: string = '.map-module';

    public trigger: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.trigger = this.element.find('.js-location-trigger');

        this.init();
    }

    init(): void {
        this.trigger.on('click', this.handleTriggerClick.bind(this));
    }

    handleTriggerClick(event: JQuery.ClickEvent): void {
        event.preventDefault();

        $(event.currentTarget).parents('.map-module__grid').toggleClass(OPEN_CLASS);
    }
}
